import { render, staticRenderFns } from "./JobCosts.vue?vue&type=template&id=560c08ec&scoped=true&"
import script from "./JobCosts.vue?vue&type=script&lang=js&"
export * from "./JobCosts.vue?vue&type=script&lang=js&"
import style0 from "./JobCosts.vue?vue&type=style&index=0&id=560c08ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c08ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressLinear,VRow,VSimpleTable,VSpacer})
